<style lang="scss" scoped>
.main {
    position: absolute !important;
    left: 200px;
    top: 108px;
    bottom: 0;
    right: 0;
    overflow: auto;
    min-width: 824px;
}
.main-info {
    padding: 32px 30px;
    border-bottom: 1px solid #e8e8e8;
    .msg {
        width: 64.7%;
        height: 120px;
        border-right: 1px solid #e8e8e8;
        font-size: 17px;
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        .avatar {
            width: 100px;
            height: 100px;
            position: absolute;
            left: -130px;
            top: 50%;
            margin-top: -50px;
            border-radius: 50%;
            overflow: hidden;
            > img {
                width: 100%;
            }
            &:hover {
                > a {
                    display: block;
                }
            }
            > a {
                position: absolute;
                display: none;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                color: white;
                text-align: center;
                line-height: 100px;
            }
        }
        .content {
            position: absolute;
            left: 130px;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
        }
        .wisdom {
            margin: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-right: 15px;
            line-height: 32px;
            height: 32px;
            font-size: 0;
            .icon-edit-pen {
                opacity: 0;
                cursor: pointer;
            }
            .edit-btn {
                display: inline-block;
                width: 12px;
                margin: 0 6px;
            }
            .form-control {
                display: inline-block;
                font-size: 0;
                box-sizing: border-box;
                padding: 0;
                font-size: 0;
                input {
                    box-sizing: border-box;
                    max-width: 150px;
                    // height: 26px;
                    height: 32px;
                    padding: 0;
                    padding-right: 20px;
                    font-size: 16px;
                    color: #4b4b4b;
                    vertical-align: middle;
                    display: inline-block;
                    border-radius: 2px;
                    line-height: 32px;
                    border: 1px solid transparent;
                    border-bottom-color: #d8d8d8;
                }
                .icons {
                    margin-left: -20px;
                    &:hover {
                        background-color: #e8e8e8;
                        border-radius: 2px;
                    }
                }
            }
        }
        h3 {
            margin: 5px 0 -2px;
            font-size: 40px;
            color: #d19f4e;
        }
        span {
            vertical-align: middle;
        }
        .nickname {
            display: inline-block;
            cursor: pointer;
            &:hover {
                .icon-edit-pen {
                    opacity: 1;
                }
            }
        }

        .name {
            display: inline-block;
            // font-weight: 500;
            max-width: 120px;
            overflow: hidden;
            font-size: 16px;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 32px;
            padding-left: 1px;
        }
    }
    .weather {
        width: 35.3%;
        height: 120px;
        font-size: 14px;
        .content {
            width: 220px;
            margin: auto;
            position: relative;
            top: 50%;
            z-index: 99;
            transform: translateY(-50%);
            > p {
                margin: 8px 0;
            }
        }
        .weather-icon {
            position: absolute;
            width: 66px;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}
.banner {
    width: 698px;
    margin: 34px auto 0;
}
.swipe-box {
    display: inline-block;
    text-align: center;
    width: 100%;
    > img {
        width: 100%;
    }
}
.swiper-slide {
    height: auto;
    width: 100%;
}
.swiper-slide > img {
    width: 100%;
}
.select {
    position: relative;
    font-size: 14px;
}
.select-container {
    width: 300px;
    height: 200px;
    background-color: #444;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
}
.blessing {
    white-space: nowrap;
    font-size: 16px;
}
hr {
    position: fixed;
    top: 175px;
    height: 1px;
    left: 200px;
    z-index: 999999;
    width: 500px;
    border: none;
    display: none;
    background-color: red;
}
.fade {
    opacity: 0 !important;
}
</style>
<style>
.swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    outline: none !important;
}
.banner .swiper-container {
    padding-bottom: 40px;
}
</style>

<template>
    <div>
        <mail-sidebar></mail-sidebar>
        <hr>
        <div class="main" v-bar>
            <div>
                <div class="main-info fix">
                    <div class="msg fl">
                        <div class="content">
                            <p class="wisdom">
                                <span class="form-control" v-if="edit" v-outside-click="cancel">
                                    <input type="text" v-model="name" maxlength="10" v-focus>
                                    <a href="javascript:;" class="icons icon-checked-bg" @click.prevent="modifyNickname"></a>
                                </span>

                                <span class="nickname" @click="onEdit">
                                    <span v-if="!edit" class="name">
                                        {{userInfo.nickname}}
                                    </span>
                                    <span class="edit-btn">
                                        <i class="icons icon-edit-pen" v-if="!edit"></i>
                                    </span>
                                </span>
                                <span class="blessing">{{blessing}}</span>
                            </p>
                            <h3>
                                <router-link :to="{name: 'unread'}">{{unreadCount}}</router-link>
                            </h3>
                            <small>未读邮件</small>
                            <!-- <img :src="userInfo.avatar" alt="" class="avatar"> -->
                            <div class="avatar">
                                <img :src="userInfo.avatar" alt="">
                                <router-link :to="{name: 'settingAvatar'}">修改头像</router-link>
                            </div>
                        </div>
                    </div>
                    <div class="weather fr" v-if="weather">
                        <div class="content">
                            <city-picker :local="weather.city" @change="getWeather"></city-picker>
                            <p>{{weather.temperature}}℃</p>
                            <p>{{weather.weather}}|{{weather.windDirect}}{{weather.windPower}}</p>
                            <img :src="weather.icon" alt="" class="weather-icon">

                        </div>
                    </div>
                </div>
                <div class="banner">
                    <swiper :options="swiperOption" ref="mySwiper" v-if="banners.length">
                        <swiper-slide v-for="item in banners" :key="item.id">
                            <a v-if="/(\w+\.)*vip.sohu.com/.test(item.adUrl)" :href="item.adUrl" class="swipe-box">
                                <img :src="item.adSrc" alt="">
                            </a>
                            <a v-else :href="item.adUrl" target="_blank" class="swipe-box">
                                <img :src="item.adSrc" alt="">
                            </a>
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination" v-show="banners.length > 1"></div>
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { swiper, swiperSlide } from "vue-awesome-swiper"
import ajax from '@/plugin/ajax'
import mailSidebar from '@/components/sidebar/mail'
import { mapState, mapActions } from 'vuex'
import utils from '@/common/utils'
import cityPicker from '@/components/city-picker'
import { getBlessing, getAdBanner, getWeather, getUserInfo } from '@/service/homeService'
import * as weatherImage from '@/data/weatherImage'
import { setSenderDisplayName } from '@/service/settingService'

export default {
    name: "homepage",
    data() {
        return {
            banners: [],
            weather: null,
            unreadCount: 0,
            timer: null,
            interval: 80,
            count: 1,
            edit: false,
            name: '',
            focusState: false,
            userInfo: {},
            swiperOption: {
                spaceBetween: 0,
                centeredSlides: true,
                loop: true,
                speed: 600,
                allowTouchMove: false,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                }
            }
        };
    },
    async created() {
        this.banners = await getAdBanner()
        this.swiperOption.loop = this.banners.length > 1
        this.getWeather(utils.getLocalStorage('postcode'))
        // this.name = this.getDisplayName()
        this.userInfo = await getUserInfo()
    },
    computed: {
        blessing: () => getBlessing(),
        ...mapState({
            unread: state => state.mailFolders.unread,
            // userInfo: state => state.userInfo
        })
    },
    components: {
        swiper,
        swiperSlide,
        mailSidebar,
        cityPicker
    },
    directives: {
        outsideClick: {
            inserted(el, binding) {
                function documentHandler(e) {
                    if (el.contains(e.target)) {
                        return false
                    }
                    if (binding.expression) {
                        binding.value(e)
                    }
                }
                el.__vueOutsideClick__ = documentHandler
                document.addEventListener("click", documentHandler)
            },
            unbind: function (el, binding) {
                document.removeEventListener("click", el.__vueOutsideClick__)
                delete el.__vueClickOutside__
            }
        },
        focus: {
            inserted(el, { value }) {
                el.focus()
            }
        }
    },
    methods: {
        ...mapActions([
            'getUserInfo'
        ]),
        countAnimation() {
            this.interval = Math.max(0, this.interval -= 5)
            clearInterval(this.timer)
            if (this.unreadCount < this.unread.unread) {
                this.unreadCount = Math.min(this.unreadCount + this.count, this.unread.unread)
                this.timer = setInterval(this.countAnimation, this.interval)
            }
        },
        async getWeather(postcode) {
            let weatherOptions = await getWeather(postcode),
                dayOrNight = weatherOptions.dayWeather ? 'day' : 'night',
                icon = `${weatherImage[weatherOptions[dayOrNight + 'Weather']]}.png`


            this.weather = {
                city: weatherOptions.cityName,
                temperature: weatherOptions[dayOrNight + 'Temperature'],
                icon: require(`../../assets/image/weather/${dayOrNight}/` + icon),
                weather: weatherOptions[dayOrNight + 'Weather'],
                windDirect: weatherOptions[dayOrNight + 'WindDirect'],
                windPower: weatherOptions[dayOrNight + 'WindPower']
            }

            utils.setLocalStorage('postcode', weatherOptions.cityCode)
        },
        modifyNickname() {
            setSenderDisplayName($.trim(this.name), this.userInfo.email).then(res => {
                this.$toast({
                    message: '保存成功',
                    theme: 'success'
                })
                getUserInfo().then(res => {
                    this.userInfo = res
                    this.edit = false
                    this.$store.commit('getUserInfo', res)
                })
            }).catch(err => {
                this.$toast({
                    message: '保存失败',
                    theme: 'danger'
                })
            })
        },
        cancel() {
            this.edit = false
            this.name = this.getDisplayName()
        },
        getDisplayName() {
            try {
                return this.userInfo.nickname || (this.userInfo.email).split('@')[0]
            } catch (err) {
                return ''
            }
        },
        onEdit() {
            this.edit = true
        }
    },
    watch: {
        unread() {
            this.count = Math.ceil(this.unread.unread / 10)
            this.timer = setInterval(this.countAnimation, this.interval)
        },
        userInfo() {
            this.name = this.getDisplayName()
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/page/mail/homepage.vue